<template>
  <div class="demo-component">
    {{ config.msg }}
  </div>
</template>

<script>
export default {
  name: "DemoComponent",
  props: {
    config: {
      type: Object,
      default() {
        return {
          msg: "Hello World"
        };
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.demo-component {
}
</style>
